import styles from './FJMobileFaceSwapThird.module.less';
import FJMobileHeaderLine from '../../../common/components/FJMobileHeaderLine/FJMobileHeaderLine.jsx';
import PropTypes from 'prop-types';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton.jsx';
import { useMemo, useState, useEffect, useRef } from 'react';
import FJFaceSwapData from '../../../config/dataConfig/FJFaceSwapData.js';
import FJConfig from '../../../config/FJConfig.js';
import FJVersionConfig from '../../../config/FJVersionConfig.js';
import FJFileUpload from '../../../common/components/FJFileUpload/FJFileUpload.jsx';
import AddIcon from '../../../assets/svg/add-gray.svg?react';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation.jsx';
import FJImage from '../../../common/components/FJImage/FJImage.jsx';
import FJLoading from '../../../common/components/FJLoading/FJLoading';

const FJMobileFaceSwapThird = props => {
    const {
        active,
        originUploadImageInfo,
        gotoBack,
        onUploadTargetImage,
        onTargetTryThose,
        taskStatus,
        freeNumCreation,
        isProjectLoading,
        onGenerate,
        creditNumber,
        targetCurLoadName,
    } = props;
    const isFree = freeNumCreation > 0 && creditNumber < 2;
    const [uploadTargetFileInfo, setUploadTargetFileInfo] = useState({});
    const [selectPreset, setSelectPreset] = useState('');
    const targetListRef = useRef(null);
    const imgBoxRef = useRef(null);
    const [imgStyle, setImgStyle] = useState({});
    const targetTryList = useMemo(() => {
        let list = FJFaceSwapData.THOSE_TARGET_IMAGES.map(item => ({
            id: item.name,
            name: item.name,
            src: FJConfig.thoseTargetImagesPath + item.name + '-min.png?v=' + FJVersionConfig.staticPathVersion,
            type: 'preset',
        }));

        if (uploadTargetFileInfo && uploadTargetFileInfo.src) {
            list.unshift({
                ...uploadTargetFileInfo,
                type: 'custom',
            });
        }
        return list;
    }, [uploadTargetFileInfo]);
    const _onUpload = file => {
        onUploadTargetImage &&
            onUploadTargetImage(file, data => {
                setUploadTargetFileInfo({ ...data, file });
                setSelectPreset(data.id);
            });
    };
    const _onTargetTryListChange = item => {
        if (item.id === selectPreset) return;
        if (item.type === 'preset') {
            onTargetTryThose(item, () => {
                setSelectPreset(item.id);
            });
        } else {
            onUploadTargetImage(item.file, data => {
                setUploadTargetFileInfo({ ...data, file: item.file });
                setSelectPreset(data.id);
            });
        }
    };
    useEffect(() => {
        if (targetListRef.current) {
            const idx = targetTryList.findIndex(item => item.id === selectPreset);
            if (idx !== -1) {
                const children = Array.from(targetListRef.current.children);
                const containerWidth = targetListRef.current.offsetWidth;
                const childrenWidth = children[idx].offsetWidth;
                const scrollLeft = children[idx].offsetLeft - 26 - childrenWidth - (containerWidth - childrenWidth) / 2;
                children[idx].offsetLeft - 26 - (containerWidth + childrenWidth) / 2;
                targetListRef.current.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth',
                });
            }
        }
    }, [selectPreset, targetTryList]);
    useEffect(() => {
        if ((imgBoxRef.current && originUploadImageInfo.src, active)) {
            const imgRatio = originUploadImageInfo.width / originUploadImageInfo.height;
            const imgBoxRect = imgBoxRef.current.getBoundingClientRect();
            const imgBoxRatio = imgBoxRect.width / imgBoxRect.height;
            if (imgRatio > imgBoxRatio) {
                setImgStyle({ width: imgBoxRect.width - 32, height: (imgBoxRect.width - 32) / imgRatio });
            } else {
                setImgStyle({ height: imgBoxRect.height - 32, width: (imgBoxRect.height - 32) * imgRatio });
            }
        }
    }, [originUploadImageInfo, imgBoxRef, active]);
    return (
        <div className={styles.container} style={{ display: active ? 'flex' : 'none' }}>
            <FJMobileHeaderLine title={FJLocalStore._('face-swap')} gotoBack={gotoBack} />
            <div className={styles.main_box} ref={imgBoxRef}>
                <img className={styles.img} style={imgStyle} src={originUploadImageInfo.src} alt='' />
            </div>
            <div className={styles.footer}>
                <div className={styles.footer_title}>{FJLocalStore._('upload-or-select-face-photo')}</div>
                <div className={styles.target_upload_box}>
                    <FJFileUpload className={styles.upload} onUpload={_onUpload}>
                        <AddIcon />
                    </FJFileUpload>
                    <div className={styles.target_list} ref={targetListRef}>
                        {targetTryList.map(item => (
                            <FJHoverBoardGradation
                                className={styles.target_item}
                                contentClassName={styles.target_item_content}
                                active={selectPreset === item.id}
                                borderRadius={10}
                                isShowInBorder={true}
                                key={item.id}
                                onClick={() => _onTargetTryListChange(item)}
                            >
                                <FJImage imgSrc={item.src} boxClassName={styles.img_box} imgClassName={styles.img} />
                                {targetCurLoadName === item.name && (
                                    <div className={styles.target_item_loading}>
                                        <FJLoading style={{ width: 16, height: 16 }} />
                                    </div>
                                )}
                            </FJHoverBoardGradation>
                        ))}
                    </div>
                </div>
                <FJGenerateButton
                    className={styles.generate_btn}
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={2}
                    isProjectLoading={isProjectLoading}
                    disabled={!selectPreset}
                />
            </div>
        </div>
    );
};

FJMobileFaceSwapThird.propTypes = {
    active: PropTypes.bool,
    originUploadImageInfo: PropTypes.object,
    gotoBack: PropTypes.func,
    onUploadTargetImage: PropTypes.func,
    onTargetTryThose: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    isProjectLoading: PropTypes.bool,
    onGenerate: PropTypes.func,
    creditNumber: PropTypes.number,
    targetUploadImageInfo: PropTypes.object,
    targetCurLoadName: PropTypes.string,
};
export default FJMobileFaceSwapThird;
